import { Route, Routes } from "react-router-dom";

import ProtectedComponent from "components/ProtectedComponent";
import CropTypes from "modules/agro/cropTypes/CropTypes";
import CropVariables from "modules/agro/cropVariables/CropVariables";
import Inputs from "modules/agro/inputs/Inputs";
import Farms from "modules/agro/farms/Farms";
import Lots from "modules/agro/lots/Lots";
import Warehouses from "modules/agro/warehouses/Warehouses";
import Collaborators from "modules/agro/collaborators/Collaborators";
import StockEntryInputs from "modules/agro/stockEntryInputs/StockEntryInputs";
import StockBioInputEntries from "modules/agro/stockBioEntryInputs/StockBioEntryInputs";
// import StockEntryTools from "modules/agro/stockEntryTool/StockEntryTools";
// import StockEntryEquipments from "modules/agro/stockEntryEquipment/StockEntryEquipments";
import Recipes from "modules/agro/recipes/Recipes";
import Trees from "modules/agro/trees/Trees";
import TechnicalVisitReports from "modules/agro/technicalVisitReports/TechnicalVisitReports";
import AgroDashboard from "modules/agro/dashboard/AgroDashboard";
import CropUnits from "modules/agro/cropUnits/CropUnits";
import Irrigations from "modules/agro/irrigations/Irrigations";
import PestAndDiseaseMonitoring from "modules/agro/pestAndDiseaseMonitoring/PestAndDiseaseMonitoring";
import GraftControl from "modules/agro/graftControl/GraftControl";
import FieldOperations from "modules/agro/fieldOperations/FieldOperations";
import EquipmentMaintenance from "modules/agro/equipmentMaintenance/EquipmentMaintenance";
import WarehouseMaintenance from "modules/agro/warehouseMaintenance/WarehouseMaintenance";
import EquipmentCalibration from "modules/agro/equipmentCalibration/EquipmentCalibration";
import Harvests from "modules/agro/harvests/Harvests";
import Sales from "modules/agro/sales/Sales";
import ExpensesAndInvestments from "modules/agro/expensesAndInvestments/ExpensesAndInvestments";
import ReportTreeCounts from "modules/agro/reports/ReportTreeCounts";
import ReportInputs from "modules/agro/reports/ReportInputs";
import ReportSales from "modules/agro/reports/ReportSales";
import ReportExpensesAndInvestments from "modules/agro/reports/ReportExpensesAndInvestments";
import ReportPYG from "modules/agro/reports/ReportPYG";

const AgroRoutes = () => (
  <Routes>
    <Route
      path="dashboard/*"
      element={<ProtectedComponent component={<AgroDashboard />} />}
    />
    <Route
      path="inputs/*"
      element={<ProtectedComponent component={<Inputs />} />}
    />
    <Route
      path="crop-types/*"
      element={<ProtectedComponent component={<CropTypes />} />}
    />
    <Route
      path="crop-variables/*"
      element={<ProtectedComponent component={<CropVariables />} />}
    />
    <Route
      path="farms/*"
      element={<ProtectedComponent component={<Farms />} />}
    />
    <Route
      path="lots/*"
      element={<ProtectedComponent component={<Lots />} />}
    />
    <Route
      path="warehouses/*"
      element={<ProtectedComponent component={<Warehouses />} />}
    />
    <Route
      path="collaborators/*"
      element={<ProtectedComponent component={<Collaborators />} />}
    />
    <Route
      path="stock-entry-input/*"
      element={<ProtectedComponent component={<StockEntryInputs />} />}
    />
    <Route
      path="stock-entry-bioinput/*"
      element={<ProtectedComponent component={<StockBioInputEntries />} />}
    />
    {/* <Route
      path="stock-entry-tool/*"
      element={<ProtectedComponent component={<StockEntryTools />} />}
    />
    <Route
      path="stock-entry-equipment/*"
      element={<ProtectedComponent component={<StockEntryEquipments />} />}
    /> */}
    <Route
      path="recipes/*"
      element={<ProtectedComponent component={<Recipes />} />}
    />
    <Route
      path="trees/*"
      element={<ProtectedComponent component={<Trees />} />}
    />
    <Route
      path="technical-visit-reports/*"
      element={<ProtectedComponent component={<TechnicalVisitReports />} />}
    />
    <Route
      path="crop-units/*"
      element={<ProtectedComponent component={<CropUnits />} />}
    />
    <Route
      path="irrigations/*"
      element={<ProtectedComponent component={<Irrigations />} />}
    />
    <Route
      path="pest-and-disease-monitoring/*"
      element={<ProtectedComponent component={<PestAndDiseaseMonitoring />} />}
    />
    <Route
      path="graft-control/*"
      element={<ProtectedComponent component={<GraftControl />} />}
    />
    <Route
      path="field-operations/*"
      element={<ProtectedComponent component={<FieldOperations />} />}
    />
    <Route
      path="equipment-maintenance/*"
      element={<ProtectedComponent component={<EquipmentMaintenance />} />}
    />
    <Route
      path="warehouse-maintenance/*"
      element={<ProtectedComponent component={<WarehouseMaintenance />} />}
    />
    <Route
      path="equipment-calibration/*"
      element={<ProtectedComponent component={<EquipmentCalibration />} />}
    />
    <Route
      path="harvests/*"
      element={<ProtectedComponent component={<Harvests />} />}
    />
    <Route
      path="sales/*"
      element={<ProtectedComponent component={<Sales />} />}
    />
    <Route
      path="expenses-and-investments/*"
      element={<ProtectedComponent component={<ExpensesAndInvestments />} />}
    />
    <Route
      path="report/tree-counts/*"
      element={<ProtectedComponent component={<ReportTreeCounts />} />}
    />
    <Route
      path="report/inputs/*"
      element={<ProtectedComponent component={<ReportInputs />} />}
    />
    <Route
      path="report/sales/*"
      element={<ProtectedComponent component={<ReportSales />} />}
    />
    <Route
      path="report/expenses-and-investments/*"
      element={<ProtectedComponent component={<ReportExpensesAndInvestments />} />}
    />
    <Route
      path="report/pyg/*"
      element={<ProtectedComponent component={<ReportPYG />} />}
    />
    <Route path="*" element={<h1>Not Found</h1>} />
  </Routes>
);

export default AgroRoutes;
